import ApiService from 'app/api/api-service';

export const addProductApi = async (args) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const url = `${BASE_URL}/api/add/directory/product/${args.directory_id}`;
  const response = await ApiService.post(url, args.data);
  return response.data;
};
